// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"RepostCampaignPreview_componentStyle__5bU2F"};